var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosPixis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 49,
    viewBox: "0 0 59 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4487 14.6884L16.7721 6.21739C17.4893 4.38788 18.7546 2.8145 20.4012 1.70461C22.0479 0.594722 23.9987 0.000410932 25.9964 0L53.7321 0C54.5115 0.00346558 55.2782 0.193061 55.9662 0.552407C56.6541 0.911753 57.2426 1.43004 57.6807 2.0625C58.1187 2.69495 58.3933 3.42255 58.4806 4.18243C58.5679 4.94232 58.4654 5.71163 58.1818 6.42391L54.8584 14.6884H13.4487ZM12.4258 17.3007L6.68743 31.942H40.1061C42.5264 31.738 44.8408 30.8763 46.7897 29.4536C48.7387 28.0309 50.245 26.1035 51.1399 23.8877L53.7949 17.3007H12.4258ZM5.66456 34.5507L0 49H12.1637C13.5702 48.9998 14.9438 48.582 16.1038 47.8015C17.2638 47.0209 18.1559 45.9142 18.6628 44.6268L22.6324 34.5507H5.66456Z",
    fill: "url(#paint0_linear_416_16034)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_416_16034",
    x1: 29.2607,
    y1: -1.88406,
    x2: 29.2607,
    y2: 50.8623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F64FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosPixis);
export default __webpack_public_path__ + "static/media/logos_pixis.ad7847ef7450d20e66f5649a79a8fa70.svg";
export { ForwardRef as ReactComponent };